module.exports = {
          srcSet: __webpack_public_path__ + "3cef6c1a31a07605427ae9cbc61b3551-801.png"+" 801w",
          images:[ {path: __webpack_public_path__ + "3cef6c1a31a07605427ae9cbc61b3551-801.png",width: 801,height: 566}],
          src: __webpack_public_path__ + "3cef6c1a31a07605427ae9cbc61b3551-801.png",
          toString:function(){return __webpack_public_path__ + "3cef6c1a31a07605427ae9cbc61b3551-801.png"},
          
          width: 801,
          height: 566
        }